import React, { useContext } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import StatusIcon from 'modules/common/components/StatusIcon';
import MemorandaModal from '../../../../modals/MemorandaModal';
import ViewFaasModal from '../ViewFaasModal';
import ViewTaxDeclarationModal from '../ViewTaxDeclarationModal';

function InformationTab({ data, type }) {
  const setModal = useContext(ModalContext);

  const handleViewFaas = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewFaasModal data={data} />,
      title: `View FAAS`,
      modalSize: 'modal-xl',
    });
  };

  const handleViewTaxDeclaration = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewTaxDeclarationModal data={data} type={type} />,
      title: `View Tax Declaration`,
      modalSize: 'modal-xl',
    });
  };

  const handleMemoranda = (item) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <MemorandaModal memorandaData={item} type={type} />,
      title: 'Memoranda',
      modalSize: 'modal-xl',
    });
  };

  return (
    <>
      <div className="row d-flex px-3 pt-3">
        <div className="d-flex ml-auto mb-3 mr-1">
          <div className="form-input-group mr-2">
            <button
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
              type="button"
              onClick={handleViewTaxDeclaration}
            >
              Tax Declaration
            </button>
          </div>
          <div className="form-input-group mr-2">
            <button
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
              type="button"
              onClick={handleViewFaas}
            >
              FAAS
            </button>
          </div>
          <div className="form-input-group mr-2">
            <button
              type="button"
              onClick={handleMemoranda(data)}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
            >
              Memoranda&nbsp;
            </button>
          </div>
        </div>
      </div>
      <div className="row px-3 pb-3">
        <div className="col-12">
          <table className="transaction-table table table-borderless table-striped table-sm">
            <tbody>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Application Status
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  <span className="transaction-text p-0">
                    <StatusIcon
                      value={_.get(data, 'attributes.display_status')}
                    />
                  </span>
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Transaction Name
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'included.transactionCode.attributes.name') ||
                    '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  ARP No.
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.arp_no') || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  PIN
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.pin') || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Owner
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.machineryOwner.attributes.full_name'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  TIN
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'included.machineryOwner.attributes.tin') ||
                    '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  TDN
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.tdn') || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Address
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.machineryOwner.attributes.full_address'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Telephone No.
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.machineryOwner.attributes.telephone_no'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <hr />
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Administrator/Beneficial User
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.beneficialUser.attributes.full_name'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Address
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.beneficialUser.attributes.full_address'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Telephone No.
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'included.beneficialUser.attributes.telephone_no'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  TIN
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'included.beneficialUser.attributes.tin') ||
                    '--'}
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <hr />
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Effectivity of Assessment / Reassessment QTR
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'attributes.effectivity_of_assessment_reassessment_qtr'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Effectivity of Assessment / Reassessment Year
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(
                    data,
                    'attributes.effectivity_of_assessment_reassessment_yr'
                  ) || '--'}
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <hr />
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Appraised/Assessed By
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.appraised_assessed_by_full_name') ||
                    '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Recommended By
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.recommending_by_full_name') || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Approved By
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.approved_by_full_name') || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Appraised/Assessed At
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.appraised_assessed_at') || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Recommended At
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.recommending_at') || '--'}
                </td>
              </tr>
              <tr>
                <td className="span-title2 font-weight-bold" width="250">
                  Approved At
                </td>
                <td className="text-dark" width="1" />
                <td className="text-dark">
                  {_.get(data, 'attributes.approved_at') || '--'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

InformationTab.defaultProps = {
  type: '',
};

InformationTab.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(InformationTab);
